import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link, Switch } from 'react-router-dom';
import { MDBContainer, MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavbarToggler, MDBCollapse, MDBNavItem, MDBNavLink, MDBIcon } from 'mdbreact';
import { withRouter, NavLink } from 'react-router-dom'
import { createBrowserHistory } from 'history';
import { Menu } from 'semantic-ui-react';
import StartGuide from './components/StartGuide'
import WhatIs from './components/WhatIs'
import CoverPage from './components/CoverPage'
import TimeLine from './components/TimeLine'
import Power28 from './components/Power28'
import PowerWeek from './components/PowerWeek'
import MakeUp from './components/MakeUp'
import LeaderBoard from './components/LeaderBoard'
import Badges from './components/Badges'
import Example from './components/Example'
import OneMoreStep from './components/OneMoreStep'
import Register2 from './modules/Register2'
import PropTypes from 'prop-types'

import Amplify from 'aws-amplify';
import { Greetings } from 'aws-amplify-react';
import aws_exports from './aws-exports';

import { sample } from 'lodash';
import Home from './modules/Home';
import Login from './modules/Login';
import Start from './modules/Start';
import Register from './modules/Register';

Amplify.Logger.LOG_LEVEL = 'DEBUG';
Amplify.configure(aws_exports);

class NavBarDaily24 extends Component {

    state = {
       collapseID: ''
    }

    toggleCollapse = collapseID => () => {
       this.setState(prevState => ({ collapseID: (prevState.collapseID !== collapseID ? collapseID : '') }));
    }

    render() {
        return (
    <nav class="navbar navbar-expand-lg navbar-light bg-custom">
  <a class="navbar-brand" to="/CoverPage"><img class="nav_logo_img" src="https://i.ibb.co/55mdkhH/slice1-3x.png" alt="slice1-3x" border="0"/></a>
    <MDBNavbarToggler onClick={this.toggleCollapse('navbarCollapse1')} />
    <MDBCollapse id="navbarCollapse1" isOpen={this.state.collapseID} navbar>
    <ul class="navbar-nav">
      <li class="nav-item">
        <MDBNavLink class="nav-link" exact to="/CoverPage" activeClassName="active" activeStyle={{fontWeight: "bold", color: "black"}}>Start</MDBNavLink>
      </li>
      <li class="nav-item">
        <MDBNavLink class="nav-link" exact to="/WhatIs" activeClassName="active" activeStyle={{fontWeight: "bold", color: "black"}}>WhatIs</MDBNavLink>
      </li>
      <li class="nav-item">
        <MDBNavLink class="nav-link" exact to="/timeline" activeClassName="active" activeStyle={{fontWeight: "bold", color: "black"}}>TimeLine</MDBNavLink>
      </li>
      <li class="nav-item">
        <MDBNavLink class="nav-link" exact to="/Power28" activeClassName="active" activeStyle={{fontWeight: "bold", color: "black"}}>Power28</MDBNavLink>
      </li>
      <li class="nav-item">
        <MDBNavLink class="nav-link" exact to="/powerWeek" activeClassName="active" activeStyle={{fontWeight: "bold", color: "black"}}>PowerWeeks</MDBNavLink>
      </li>
      <li class="nav-item">
        <MDBNavLink class="nav-link" exact to="/example" activeClassName="active" activeStyle={{fontWeight: "bold", color: "black"}}>Example</MDBNavLink>
      </li>
      <li class="nav-item">
        <MDBNavLink class="nav-link" exact to="/leaderboard" activeClassName="active" activeStyle={{fontWeight: "bold", color: "black"}}>Leaderboard</MDBNavLink>
      </li>
      <li class="nav-item">
        <MDBNavLink class="nav-link" exact to="/badges" activeClassName="active" activeStyle={{fontWeight: "bold", color: "black"}}>Badges</MDBNavLink>
      </li>
      <li class="nav-item">
        <MDBNavLink class="nav-link" exact to="/makeUp" activeClassName="active" activeStyle={{fontWeight: "bold", color: "black"}}>MakeUp</MDBNavLink>
      </li>
      <li class="nav-item">
        <MDBNavLink class="nav-link" exact to="/oneMoreStep" activeClassName="active" activeStyle={{fontWeight: "bold", color: "black"}}>OneMoreStep</MDBNavLink>
      </li>
      <li class="nav-item">
        <MDBNavLink class="nav-link" exact to="/register2" activeClassName="active" activeStyle={{fontWeight: "bold", color: "black"}}>Register</MDBNavLink>
      </li>
    </ul>
      </MDBCollapse>
</nav>
        );
    }
  }
    NavBarDaily24.contextThypes = {
        router: PropTypes.object
    };

    export default NavBarDaily24;



// WEBPACK FOOTER //
// ./src/NavBarDaily24.js